export interface DiffStatTextPart {
  text: string;
  kind?: 'add' | 'remove';
}

const COUNT_PART = /^[+\-−]\d+$/;
const COUNT_START = /(?:^|[\s([{,:])$/;
const COUNT_END = /^(?:$|[\s)\]};!?]|,(?!\d)|[.:](?=\s|$))/;

/** Match complete signed counts, never fragments of names, dates or decimals. */
export const splitDiffStatText = (value: string): DiffStatTextPart[] => {
  const counts = /[+\-−]\d+(?:\/[+\-−]\d+)*/g;
  const parts: DiffStatTextPart[] = [];
  let cursor = 0;
  let match: RegExpExecArray | null;

  while ((match = counts.exec(value)) !== null) {
    const end = match.index + match[0].length;

    if (!COUNT_START.test(value.slice(0, match.index)) || !COUNT_END.test(value.slice(end))) continue;
    if (match.index > cursor) parts.push({ text: value.slice(cursor, match.index) });
    // A compact diff pair such as +12/-3 keeps its slash as ordinary text.
    match[0].split(/([+\-−]\d+)/).filter(Boolean).forEach((text) => {
      parts.push(COUNT_PART.test(text) ? { text, kind: text.startsWith('+') ? 'add' : 'remove' } : { text });
    });
    cursor = end;
  }
  if (cursor < value.length) parts.push({ text: value.slice(cursor) });

  return parts;
};
